<template>
      <a-col>
        <div class="provisioning_btn_container">
            <a-button block class="green_bg step_btn" size="large" @click="handleInputSubmit" :disabled="isLoading">開通裝置</a-button>
        </div>
      </a-col>
</template>

<script>
    import { mapActions, mapGetters, mapState } from 'vuex';
    import { mixinSendSmsMethods } from "../../utils/mixins";

    export default {
        name: 'ProvisioningOpenDeviceButton',
        mixins: [ mixinSendSmsMethods ],
        data() {
            return {
                isNameEmpty: true,
                hasNameIllegalCharacters: false,
                isCarNoInvalid: true,
                isPhoneInvalid: true,
                msgObj: {
                    visible: false,
                    title: '發送錯誤',
                    okText: '確認',
                    cancelText: '',
                    detailText: '',
                    msgClass: 'msg_confirm_modal',
                },
                isChecked: false,
                isLoading: false,
            }
        },
        methods: {
            ...mapActions('identidyInputVerification', ['identidyInputAction']),
            checkFieldVaild(info) {
                for (const key in info) {
                    if (Object.hasOwnProperty.call(info, key)) {
                        let carNoResult = false;
                        let phoneResult = false;
                        switch (key) {
                            case 'name':
                                // 檢查名字是否空白
                                this.isNameEmpty = !info[key].trim() ? true : false;
                                // 名字有輸入時，檢查名字是否有不合法的特殊符號 且小於32個字
                                if (!this.isNameEmpty) this.hasNameIllegalCharacters = (/[!@#$%^&*|+=~]/g.test(info[key].trim())||info[key].trim().length>32);
                                break;
                            case 'carNo':
                                // 檢查車號是否空白
                                if (!info[key].trim()) carNoResult = true;
                                // 檢查車號是否有除了數字、英文、'-'以外的字
                                else if (/[^A-Za-z0-9-]/g.test(info[key].trim())) carNoResult = true;
                                // 檢查車號是否只含有一個'-'
                                else if (!info[key].trim().match(/[-]/g)|| info[key].trim().match(/[-]/g).length > 1) carNoResult = true;

                                this.isCarNoInvalid = carNoResult;
                                break;
                            case 'phone':
                                // 檢查手機號碼是否空白
                                if(!info[key]) {
                                    phoneResult = true;
                                }
                                // 把'-'拿掉後，檢查手機號碼長度是否超過限制
                                else if (info[key].replace(/-/g,'').length !== 10) {
                                    phoneResult = true;
                                }

                                this.isPhoneInvalid = phoneResult;
                                break;
                            default:
                                break;
                        }
                    }
                }
                console.log('infoStateObj', this.infoStateObj);
                this.isChecked = true;
            },
            async handleInputSubmit() {
                this.checkFieldVaild(this.identidyInfo);
                await this.saveIdentidyInfoStateObj();

                if (this.isNameEmpty || this.hasNameIllegalCharacters || this.isCarNoInvalid || this.isPhoneInvalid) return;
                else {
                  this.setLoadingState(true);
                  const { name,carNo } = this.identidyInfo;
                    const params = {
                        // openedName: name,
                        // openedCarNo: carNo,
                        // openedMobile: this.withoutDashPhoneNumber,
                        // deviceUid: this.deviceUid,
                      carNo:carNo,
                      phoneNum: this.withoutDashPhoneNumber,
                      name,
                    };
                    await this.sendSmsToPhone(params);
                    this.setLoadingState(false);
                }
            },
            async saveIdentidyInfoStateObj() {
                try {
                    this.identidyInputAction(this.infoStateObj);
                } catch (error) {
                    console.log(error);
                }
            },
            setLoadingState(isLoading) {
              this.isLoading = isLoading;
              this.$emit('loading', isLoading);
            }
        },
        computed: {
            ...mapState('identidyOpenStatus', ['deviceUid']),
            ...mapState('identidyInfo', ['identidyInfo']),
            ...mapGetters('identidyInfo', ['withoutDashPhoneNumber']),
            infoStateObj() {
                return {
                    isNameEmpty: this.isNameEmpty,
                    hasNameIllegalCharacters: this.hasNameIllegalCharacters,
                    isCarNoInvalid: this.isCarNoInvalid,
                    isPhoneInvalid: this.isPhoneInvalid,
                }
            }
        },
        beforeRouteLeave(to, from, next) {
          console.log(to, from, next);
        }
    }
</script>

<style lang="scss" scoped>
  .provisioning_btn_container {
      margin-top: 45px;
  }
</style>
